import React from 'react'

import IconButton from 'components/buttons/icon'
import { faExternalLink } from '@fortawesome/pro-light-svg-icons/faExternalLink'

const ExternalLinkButton = ({ link, title, children }) => {
  return (
    <a href={link} target='_blank' rel='noopener noreferrer'>
      {title && <IconButton icon={faExternalLink} title={title} />}
      {children}
    </a>
  )
}

export default ExternalLinkButton
